/* 韦氏全局方法 */
import locales from '@/components/language/app.js'
var curLang =  locales[localStorage.system_lang]
const sha256 = require("js-sha256").sha256

export default{
  install (Vue) {
    Vue.prototype.$installType = {0: curLang.app_autoInstall, 1: curLang.app_cantuins}
    Vue.prototype.$firmwareTypes = [
      {label: 'KEY', vl: 'KEY'},
      {label: 'FLASH', vl: 'FLASH'},
      {label: 'KOS', vl: 'KOS'},
      {label: 'RES', vl: 'RES'},
      {label: 'KSP', vl: 'KSP'},
      {label: 'HEX', vl: 'HEX'}
    ]

    Vue.prototype.$gRow = 10
    Vue.prototype.$gRows = [10,50,100]
    Vue.prototype.$legalSysPsw = function (ct) {
      // char num uline
      return this.$strCheck(ct,'^\\w+$')
    }
    Vue.prototype.$strCheck = function (ct, rule) {
      var patt = new RegExp(rule)
      return patt.test(ct)
    }

    Vue.prototype.$sha256 = function (vl) {
      return sha256(sha256(vl+'szzt@002197'))
    }

    Vue.prototype.$showConfirm = function (title, content, cfbtn, clbtn, type, sureCb, otherCb) {
      this.$confirm(content, title, {
        confirmButtonText: cfbtn,
        cancelButtonText: clbtn,
        type: type
      }).then(() => {
        if (sureCb) {
          sureCb()
        }
      }).catch(() => {
        if (otherCb) {
          otherCb()
        }
      })
    }
    Vue.prototype.$getWObj = function () {
      if (JSON) {
        if (!localStorage.wobj) {
          var obj = {
            // 新建数据s配置 type:0新建 1编辑 pageType 0渠道 1厂商
            editDataConfig: {
              pageType: 0,
              type: 0,
              data: ''
            },
            editAppConfig: {
              type: 0, // 0新建 1编辑 2展示 3审核
              data: ''
            },
            otaPushInfo: '',
            appBindInfo: '',
            missionInfo: '', // 任务信息
            animatePushInfo: '', // 动画推送对象
            info: '',
            pages: {
              appPage: 1,
              appMarketPage: 1,
              appMarketAddPage: 1,
              appMarketPushPage: 1,
              appMarketTerPage: 1,
              appVerifyPage: 1,
              missionListPage: 1,
              missionDetailPage: 1,
              dataChannelPage: 1,
              dataFirmPage: 1,
              firmwarePage: 1, // 固件分页
              firmwareCheckPage: 1 // 固件审核分页
            }
          }
          localStorage.wobj = JSON.stringify(obj)
        }
        // console.log(localStorage.wobj)
        return JSON.parse(localStorage.wobj)
      }
    }
    Vue.prototype.$setWObj = function (key, vl) {
      if (JSON) {
        // console.log('key vl', key, vl)
        var obj = Vue.prototype.$getWObj()
        obj[key] = vl
        localStorage.wobj = JSON.stringify(obj)
      }
    }
    Vue.prototype.$cleanWObj = function () {
      localStorage.wobj = ''
    }
    Vue.prototype.$setWPage = function (prop, index) {
      var wobj = Vue.prototype.$getWObj()
      var pages = wobj.pages
      pages[prop] = index
      Vue.prototype.$setWObj('pages', pages)
    }
    Vue.prototype.$getWPage = function (prop) {
      var wobj = Vue.prototype.$getWObj()
      var index = wobj.pages[prop]
      // console.log(prop, index, wobj)
      return index
    }
    Vue.prototype.$getProjFolder = function () {
      var rs = location.href
      var urlpre = rs.substring(0, rs.indexOf('#'))
      return urlpre
      // return  urlpre.replace(location.origin, '')
    }
    Vue.prototype.$plang = {
      en: {
        tip: 'Prompt',
        upTip: 'A file is being uploaded, and is it sure to leave the page',
        sure: 'Determine',
        cancel: 'Cancel'
      },
      ko: {
        tip: '팁',
        upTip: '파일 업로드 중 여부를 떠나 있는 건 이 페이지',
        sure: '확정',
        cancel: '취소'
      },
      ru: {
        tip: 'подсказки ',
        upTip: ' есть  в настоящее время  загрузить  файл  , чтобы определить, является ли  покинуть  эту страницу ',
        sure: 'Определения ',
        cancel: 'отменить '
      },
      zh_cn: {
        tip: '提示',
        upTip: '有文件正在上传, 是否确定离开此页面',
        sure: '确定',
        cancel: '取消'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/wGlobalMethods.js